{
  "sessionsCount_one": "{{count}} sessão",
  "sessionsCount_zero": "{{count}} sessões",
  "sessionsCount_other": "{{count}} sessões",
  "viewersCount_one": "{{count}} aluno",
  "viewersCount_zero": "{{count}} alunos",
  "viewersCount_other": "{{count}} alunos",
  "title": "Vídeos",
  "subtitle": "Envie, organize e acompanhe os vídeos das aulas. Os vídeos são entregues por streaming protegido, só dentro da área de membros.",
  "loading": "Carregando vídeos...",
  "loadError": "Não foi possível carregar os vídeos.",
  "empty": "Nenhum vídeo enviado ainda.",
  "notFound": "Vídeo não encontrado.",
  "back": "Voltar para vídeos",
  "openStudio": "Abrir no estúdio",
  "failedReason": "Falha no processamento: {{reason}}",
  "pagination": {
    "label": "Paginação",
    "previous": "Anterior",
    "next": "Próxima",
    "status": "Página {{page}} de {{total}}"
  },
  "status": {
    "UPLOADING": "Aguardando envio",
    "PROCESSING": "Processando",
    "READY": "Pronto",
    "FAILED": "Falhou"
  },
  "visibility": {
    "PRIVATE": "Privado",
    "SHAREABLE": "Compartilhável",
    "PUBLIC": "Público"
  },
  "visibilityHint": {
    "PRIVATE": "Só alunos com acesso à aula assistem, dentro da área de membros.",
    "SHAREABLE": "Reservado para links de compartilhamento (em breve). Por enquanto funciona como Privado.",
    "PUBLIC": "Qualquer pessoa assiste sem login, mas só nos domínios da sua área de membros."
  },
  "upload": {
    "cta": "Clique ou arraste um vídeo para enviar",
    "hint": "Streaming protegido em até 4K · máx. 20 GB",
    "sending": "Enviando vídeo...",
    "done": "Vídeo enviado. O processamento começa em instantes.",
    "error": "Não foi possível enviar o vídeo.",
    "unsupported": "Arquivo não suportado. Envie um arquivo de vídeo.",
    "tooLarge": "Vídeo muito grande ({{size}}). Máximo: 20 GB."
  },
  "delete": {
    "button": "Excluir vídeo",
    "title": "Excluir vídeo?",
    "description": "As aulas que usam este vídeo deixam de reproduzi-lo. Essa ação não pode ser desfeita.",
    "confirm": "Excluir"
  },
  "toasts": {
    "deleted": "Vídeo excluído",
    "error": "Não foi possível concluir a ação.",
    "saved": "Alterações salvas",
    "thumbnailUpdated": "Thumbnail atualizada",
    "subtitleSaved": "Legenda salva",
    "subtitleRemoved": "Legenda removida"
  },
  "details": {
    "title": "Detalhes",
    "name": "Título",
    "description": "Descrição",
    "visibility": "Visibilidade",
    "save": "Salvar",
    "watermarkText": "Texto da marca d'água",
    "watermarkHint": "Aparece sobre o vídeo no player. A alteração vale na próxima reprodução, sem reprocessar o vídeo.",
    "watermarkCustom": "Texto personalizado",
    "watermarkPosition": "Posição da marca d'água"
  },
  "thumbnails": {
    "title": "Thumbnail",
    "description": "Escolha uma das sugestões, capture o frame pausado no player ou envie uma imagem.",
    "candidate": "Usar sugestão {{index}}",
    "custom": "Thumbnail atual",
    "useFrame": "Usar frame em {{time}}",
    "upload": "Enviar imagem",
    "frameHint": "Dê play e pause no ponto desejado para capturar o frame."
  },
  "subtitles": {
    "title": "Legendas",
    "description": "Envie arquivos SRT ou WebVTT. Cada idioma tem uma legenda.",
    "empty": "Nenhuma legenda enviada.",
    "remove": "Remover legenda {{label}}",
    "removeConfirm": "Remover a legenda \"{{label}}\"?",
    "lang": "Idioma",
    "label": "Nome exibido",
    "chooseFile": "Escolher arquivo",
    "noFile": "Nenhum arquivo selecionado",
    "add": "Salvar legenda",
    "invalidFile": "Arquivo de legenda inválido.",
    "replaceWarning": "Já existe uma legenda em {{language}}. Ela será substituída ao salvar.",
    "replace": "Substituir legenda"
  },
  "analytics": {
    "title": "Audiência",
    "viewers": "Alunos",
    "sessionsHint_one": "{{count}} sessão",
    "sessionsHint_zero": "{{count}} sessões",
    "sessionsHint_other": "{{count}} sessões",
    "watchedHours": "Tempo assistido",
    "avgCoverage": "Média assistida",
    "completed": "Concluíram",
    "completedHint": "Assistiram 90% ou mais",
    "byViewer": "Por aluno",
    "bySession": "Sessões",
    "viewer": "Aluno",
    "sessions": "Sessões",
    "coverage": "Assistido",
    "watched": "Tempo",
    "lastSeen": "Último acesso",
    "startedAt": "Início",
    "device": "Navegador e dispositivo",
    "location": "Local",
    "endReason": "Encerramento",
    "empty": "Ainda não há visualizações.",
    "valuesTitle": "Custos e uso no período"
  },
  "endReason": {
    "ACTIVE": "Assistindo",
    "ENDED": "Saiu da aula",
    "EXPIRED": "Inativa",
    "REPLACED": "Aberta em outro lugar"
  },
  "reupload": {
    "title": "Reenviar arquivo",
    "description": "Envie o arquivo de novo para este mesmo vídeo. As aulas que já usam o vídeo continuam vinculadas."
  },
  "usage": {
    "title": "Uso de vídeo",
    "month": "Mês",
    "storage": "Armazenamento",
    "storageHint_one": "{{count}} vídeo",
    "storageHint_zero": "{{count}} vídeos",
    "storageHint_other": "{{count}} vídeos",
    "processed": "Processado no período",
    "processedHint": "Saída: SD {{sd}} · HD {{hd}} · 4K {{uhd}} min",
    "watched": "Assistido no período",
    "watchedHint": "$t(adminVideos:sessionsCount, {\"count\": {{sessions}} }) · $t(adminVideos:viewersCount, {\"count\": {{viewers}} }) · {{data}} baixados",
    "gb": "{{value}} GB",
    "minutes": "{{value}} min",
    "cost": "Custo estimado",
    "costHint": "Armazenamento {{storage}} · Processamento {{processing}} · Entrega {{delivery}}"
  },
  "tenantUsage": {
    "title": "Uso de vídeo por escola",
    "subtitle": "Volume de vídeo por escola no período e o custo real do Google Cloud.",
    "loadError": "Não foi possível carregar o uso.",
    "empty": "Nenhuma escola encontrada.",
    "name": "Escola",
    "videos": "Vídeos",
    "storage": "Armazenamento (GB)",
    "processed": "Processados (min)",
    "watched": "Assistidos (min)",
    "costStorage": "Armazenamento",
    "costProcessing": "Processamento",
    "costDelivery": "Entrega",
    "costTotal": "Total",
    "grandTotal": "Total geral",
    "platform": "Plataforma (não alocado)"
  },
  "failure": {
    "FILE_TOO_LARGE": "o arquivo passa do limite de 20 GB.",
    "NO_VIDEO_STREAM": "o arquivo não tem uma faixa de vídeo válida.",
    "VIDEO_TOO_SHORT": "o vídeo precisa ter pelo menos 5 segundos.",
    "PROBE_FAILED": "não foi possível ler o arquivo. Ele pode estar corrompido ou num formato não suportado."
  },
  "watermarkText": {
    "NONE": "Nenhum",
    "USER_EMAIL": "E-mail do usuário",
    "TENANT_NAME": "Nome da escola",
    "VIDEO_ID": "Código do vídeo",
    "CUSTOM": "Personalizado"
  },
  "watermarkPosition": {
    "TOP_RIGHT": "Superior direita",
    "BOTTOM_RIGHT": "Inferior direita",
    "BOTTOM_LEFT": "Inferior esquerda",
    "TOP_LEFT": "Superior esquerda",
    "FLOATING": "Flutuante"
  },
  "library": {
    "tabs": {
      "videos": "Vídeos",
      "viewers": "Alunos e custos"
    },
    "searchPlaceholder": "Buscar por título",
    "statusFilter": "Filtrar por status",
    "allStatuses": "Todos os status",
    "noResults": "Nenhum vídeo encontrado para essa busca.",
    "columns": {
      "video": "Vídeo",
      "visibility": "Visibilidade",
      "date": "Data",
      "views": "Visualizações",
      "watchTime": "Tempo assistido",
      "subtitles": "Legendas",
      "data": "Dados baixados",
      "storage": "Armazenamento",
      "cost": "Custo"
    },
    "selectAll": "Selecionar todos os vídeos da página",
    "selectOne": "Selecionar {{title}}",
    "selected_one": "{{count}} selecionado",
    "selected_zero": "{{count}} selecionados",
    "selected_other": "{{count}} selecionados",
    "clearSelection": "Limpar seleção",
    "bulkVisibility": "Alterar visibilidade",
    "bulkDelete": "Excluir",
    "bulkDeleteTitle": "Excluir vídeos selecionados?",
    "bulkDeleteDescription_one": "O vídeo selecionado será excluído. Aulas que usam esse vídeo deixarão de tocar.",
    "bulkDeleteDescription_zero": "Os {{count}} vídeos selecionados serão excluídos. Aulas que usam esses vídeos deixarão de tocar.",
    "bulkDeleteDescription_other": "Os {{count}} vídeos selecionados serão excluídos. Aulas que usam esses vídeos deixarão de tocar.",
    "bulkUpdated": "Visibilidade atualizada.",
    "bulkDeleted": "Vídeos excluídos.",
    "bulkPartial": "{{failed}} de {{total}} vídeos não puderam ser alterados.",
    "openStudio": "Abrir {{title}} no estúdio",
    "delete": "Excluir {{title}}",
    "subtitleCount_one": "{{count}} idioma",
    "subtitleCount_zero": "{{count}} idiomas",
    "subtitleCount_other": "{{count}} idiomas",
    "noSubtitles": "Sem legenda",
    "details": {
      "expand": "Ver métricas de {{title}}",
      "collapse": "Ocultar métricas de {{title}}",
      "cost": "Custo no período",
      "watchedHint": "$t(adminVideos:sessionsCount, {\"count\": {{sessions}} }) · $t(adminVideos:viewersCount, {\"count\": {{viewers}} }) · {{data}} baixados",
      "costBreakdown": "Entrega {{delivery}} · Armazenamento {{storage}} · Processamento {{processing}}"
    }
  },
  "viewersPage": {
    "title": "Alunos e custos",
    "subtitle": "Veja o que cada aluno assistiu, quanto de cada vídeo já viu e quanto isso custou e vai ser cobrado no período.",
    "month": "Mês",
    "search": "Buscar aluno por nome ou e-mail",
    "loading": "Carregando alunos...",
    "loadError": "Não foi possível carregar o uso por aluno.",
    "empty": "Nenhum aluno assistiu vídeos neste período.",
    "noMatch": "Nenhum aluno encontrado para essa busca.",
    "totals": {
      "viewers": "Alunos",
      "watched": "Tempo assistido",
      "cost": "Custo total",
      "charge": "A cobrar",
      "chargeHint": "Margem aplicada: {{percent}}%"
    },
    "columns": {
      "student": "Aluno",
      "videos": "Vídeos",
      "watched": "Tempo assistido",
      "cost": "Custo de entrega",
      "charge": "A cobrar",
      "lastSeen": "Última vez",
      "progress": "Progresso",
      "sessions": "Sessões",
      "data": "Dados baixados"
    },
    "anonymous": "Acesso público (sem login)",
    "removedVideo": "Vídeo removido",
    "expand": "Ver vídeos de {{name}}",
    "collapse": "Ocultar vídeos de {{name}}",
    "exportCsv": "Exportar CSV",
    "csv": {
      "student": "Aluno",
      "email": "E-mail",
      "video": "Vídeo",
      "watchedSeconds": "Segundos assistidos",
      "progress": "Progresso (%)",
      "cost": "Custo de entrega (USD)",
      "charge": "A cobrar (USD)",
      "data": "Dados baixados (GB)"
    },
    "note": "Por aluno mostramos só a entrega. O custo é o real do Google Cloud, repartido pelo que cada aluno baixou; onde aparece \"—\", o Google Cloud ainda não informou o custo daquele período. Armazenamento e processamento são custos do curso e entram no custo total. O valor não inclui lucro.",
    "estimated": "Parte estimada: o navegador do aluno não informou o consumo."
  },
  "dateRange": {
    "from": "De",
    "to": "Até",
    "placeholder": "DD/MM/AAAA",
    "order": "A data inicial não pode ser depois da final.",
    "presets": {
      "thisMonth": "Este mês",
      "lastMonth": "Mês passado",
      "last30": "Últimos 30 dias"
    }
  },
  "picker": {
    "tabs": {
      "upload": "Enviar novo",
      "existing": "Usar existente"
    },
    "search": "Buscar vídeo pelo título",
    "empty": "Você ainda não tem vídeos prontos. Envie um novo.",
    "select": "Usar o vídeo {{title}}",
    "views_one": "{{count}} visualização",
    "views_zero": "{{count}} visualizações",
    "views_other": "{{count}} visualizações",
    "usedIn_one": "Usado em {{count}} aula",
    "usedIn_zero": "Usado em {{count}} aulas",
    "usedIn_other": "Usado em {{count}} aulas",
    "unused": "Ainda sem aulas"
  },
  "costs": {
    "title": "Custos",
    "provisional": "Provisório",
    "refresh": "Atualizar agora",
    "synced": "Custos atualizados.",
    "asOf": "Dados reais do Google Cloud até {{date}}",
    "categories": {
      "delivery": "Entrega (CDN)",
      "storage": "Armazenamento",
      "processing": "Processamento"
    },
    "real": "Real",
    "pending": "Aguardando dados reais do Google Cloud.",
    "partial": "Parte do período ainda sem dados reais do Google Cloud."
  },
  "studioTabs": {
    "settings": "Definições",
    "analytics": "Analytics"
  }
}
